module.exports = __webpack_public_path__ + "img/icone-webhook.3a36b5a5.svg";